import React, { useEffect } from 'react';
import { CustomAccordion } from '../../components/Accordion';
import { BusinessCustomListItemStyled, DetailsIconBox, IconBox } from './style';
import { Box, Checkbox, Divider, IconButton, Typography, useTheme } from '@mui/material';
import FilledTickIcon from '../../icons/FilledTickIcon';
import RoundRingIcon from '../../icons/RoundRingIcon';
import BankAccountIcon from '../../icons/BankAccountIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import FormationIcon from '../../icons/FormationIcon';
import AccountingIcon from '../../icons/AccountingIcon';
import TaxPlanningIcon from '../../icons/TaxPlanningIcon';
import PaperBoxIcon from '../../icons/PaperBoxIcon';
import ManagementIcon from '../../icons/ManagementIcon';
import SpeakerIcon from '../../icons/SpeakerIcon';
import TechIcon from '../../icons/TechIcon';
import PersonIconTwo from '../../icons/PersonIconTwo';
import { CustomChip } from '../../components/CustomChip';
import HandShakeIcon from '../../icons/HandShakeIcon';
import DeleteIcon from '@mui/icons-material/Delete';

function BusinessListItem({ cItem, currentSelectedItem, setCurrentSelectedItem, index, selectedItemDetails, toggleDrawer, expandedItemId, setExpandedItemId, openDeleteTaskModal, updateChecklists }) {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const handleClick = (currentItem) => {
        setCurrentSelectedItem(currentItem);
        selectedItemDetails = {
            selectedNavId: cItem.id,
            selectedListItemId: currentItem.id,
        };

        const newParams = new URLSearchParams(location.search);
        newParams.set('selectedNavId', cItem.id);
        newParams.set('selectedListItemId', currentItem.id);
        navigate(`${location.pathname}?${newParams.toString()}`);

        //handling drawer state in useEffect of index file
        // toggleDrawer(true);
    };

    const handleCheckBox = (currentCheckItem, isChecked) => {
        let newChecklistItem = {
            ...currentCheckItem,
        };
        if (isChecked) {
            const newCompanyTasks = currentCheckItem?.companyTasks?.map((cTodoItem) => ({
                ...cTodoItem,
                status: 'Completed',
            }));

            newChecklistItem.companyTasks = newCompanyTasks;
        } else {
            const newCompanyTasks = currentCheckItem?.companyTasks?.map((cTodoItem) => ({
                ...cTodoItem,
                status: 'Not started',
            }));

            newChecklistItem.companyTasks = newCompanyTasks;
        }

        setCurrentSelectedItem(newChecklistItem);
        updateChecklists(newChecklistItem);

        // let newItem = { ...currentCheckItem, status: isChecked };
        // updateTaskStatus(todoItemList.map((item) => (item.id === newItem.id ? newItem : item)));
        // post('custom/updateCompanyTasksStatus', { recordId: newItem.id, status: isChecked });
    };

    useEffect(() => {
        if (cItem.id === selectedItemDetails.selectedNavId) {
            setExpandedItemId(cItem.id);
        }
    }, [selectedItemDetails.selectedNavId]);

    const getStatusTag = (item) => {
        return (
            <Typography component={'span'} variant="paraText2" color={'gray.700'} marginRight={theme.typography.generic.xSmall} marginLeft={theme.typography.generic.xSmall} whiteSpace={'pre'}>
                {item.companyTasks.filter((innerItem) => innerItem.status === 'Completed').length} / {item.companyTasks?.length} Complete
            </Typography>
        );
    };

    const getIcon = (status) => {
        if (status === 'LLC Formation') {
            return <FormationIcon />;
        } else if (status === 'Banking & Accounting') {
            return <AccountingIcon />;
        } else if (status === 'Tax Planning') {
            return <TaxPlanningIcon />;
        } else if (status === 'Legal & Compliance') {
            return <PaperBoxIcon />;
        } else if (status === 'Risk Management') {
            return <ManagementIcon />;
        } else if (status === 'Branding & Marketing') {
            return <SpeakerIcon />;
        } else if (status === 'IT & Technology') {
            return <TechIcon />;
        } else if (status === 'Human Resources') {
            return <PersonIconTwo />;
        }
    };
    const getIconUsingName = (name) => {
        if (name === 'LLC Formation') {
            return <FormationIcon />;
        } else if (name === 'Banking & Accounting') {
            return <AccountingIcon />;
        } else if (name === 'Tax Planning & Preparation') {
            return <TaxPlanningIcon />;
        } else if (name === 'Legal & Compliance') {
            return <PaperBoxIcon />;
        } else if (name === 'Risk Management & Insurance') {
            return <ManagementIcon />;
        } else if (name === 'Branding & Marketing') {
            return <SpeakerIcon />;
        } else if (name === 'IT & Technology') {
            return <TechIcon />;
        } else if (name === 'Human Resources') {
            return <PersonIconTwo />;
        } else if (name === 'Public Relations') {
            return <HandShakeIcon />;
        } else {
            return <BankAccountIcon />;
        }
    };

    const getStatus = (item) => {
        let status = '';

        if (item.companyTasks.filter((innerItem) => innerItem.status === 'Completed').length === item.companyTasks.length) {
            status = 'Completed';
        } else if (item.companyTasks.filter((innerItem) => innerItem.status === 'Not started').length === item.companyTasks.length) {
            status = 'Not started';
        } else {
            status = 'In Progress';
        }
        return status;
    };

    const sortedTasks = Array.isArray(cItem.tasks)
        ? [...cItem.tasks]
              // Step 1: Sort by order (undefined/null values go to the end)
              .sort((a, b) => {
                  const orderA = a.order;
                  const orderB = b.order;

                  const hasOrderA = typeof orderA === 'number';
                  const hasOrderB = typeof orderB === 'number';

                  if (hasOrderA && hasOrderB) {
                      return orderA - orderB;
                  } else if (hasOrderA) {
                      return -1; // a has order, b doesn't — a comes first
                  } else if (hasOrderB) {
                      return 1; // b has order, a doesn't — b comes first
                  } else {
                      return 0; // neither has order — keep relative position
                  }
              })
              // Step 2: Push completed tasks to the bottom
              .sort((a, b) => {
                  const isCompletedA = getStatus(a) === 'Completed';
                  const isCompletedB = getStatus(b) === 'Completed';

                  if (isCompletedA && !isCompletedB) return 1;
                  if (!isCompletedA && isCompletedB) return -1;
                  return 0; // same status
              })
        : [];

    return (
        <CustomAccordion
            index={index}
            summary={
                <>
                    <IconBox component="div">
                        {getIconUsingName(cItem.name)}
                        {/* {getIcon(cItem.icon)} */}
                    </IconBox>
                    <Box sx={{ ml: 2 }}>
                        <Typography component={'h2'} variant="paraText1" color={'text.primary'}>
                            {cItem.name}
                        </Typography>

                        <Typography variant="paraText5" color={'gray.700'}>
                            {cItem.tasks?.length ? cItem.tasks?.length : 0} Tasks
                        </Typography>
                    </Box>
                </>
            }
            details={
                <>
                    <Divider
                        sx={{
                            margin: `${theme.typography.generic.none} `,
                        }}
                    />
                    <Box
                        component={'ul'}
                        sx={{
                            padding: '1rem',
                            '& li': {
                                marginBottom: '0.5rem',

                                '&:last-child': {
                                    marginBottom: 0,
                                },
                            },
                        }}
                    >
                        {sortedTasks?.map((currentItem, index) => {
                            return (
                                <BusinessCustomListItemStyled
                                    key={index}
                                    isClicked={currentSelectedItem.id === currentItem.id}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => handleClick(currentItem)}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            event.preventDefault();
                                            handleClick(currentItem);
                                        }
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: { sm: '45%', xs: '100%' },
                                            minWidth: { sm: '45%', xs: '100%' },

                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {/* {getDetailsTag(currentItem)} */}
                                        <Checkbox
                                            checked={getStatus(currentItem) === 'Completed' ? true : false}
                                            onChange={(event) => {
                                                handleCheckBox(currentItem, event.target.checked);
                                            }}
                                            icon={
                                                <RoundRingIcon
                                                    style={{
                                                        color: theme.palette.text.tertiary,
                                                    }}
                                                />
                                            }
                                            checkedIcon={<FilledTickIcon />}
                                            sx={{
                                                margin: '-9px',
                                                marginTop: '-6px',
                                                '& svg': {
                                                    width: 24,
                                                    height: 24,
                                                },
                                            }}
                                        />
                                        <Typography component={'span'} variant="paraText2" color={'text.secondary'} ml={1}>
                                            {currentItem.name}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            width: { sm: '55%', xs: '100%' },
                                            minWidth: { sm: '55%', xs: '100%' },
                                            display: 'flex',
                                            paddingLeft: {
                                                xs: '2rem',
                                                sm: 'unset',
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: { sm: '50%', xs: 'unset' },
                                                minWidth: { sm: '50%', xs: 'unset' },

                                                display: 'flex',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <CustomChip label={`${currentItem.companyTasks?.length} Companies`} />
                                        </Box>

                                        <Box
                                            sx={{
                                                width: { sm: '50%', xs: 'unset' },
                                                minWidth: { sm: '50%', xs: 'unset' },

                                                display: 'flex',
                                                justifyContent: { sm: 'flex-end', xs: 'center' },
                                                alignItems: {
                                                    xs: 'center',
                                                    sm: 'center',
                                                },
                                            }}
                                        >
                                            {/* {getStatusTag(currentItem)} */}
                                            <IconButton
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    openDeleteTaskModal(currentItem);
                                                }}
                                                aria-label="delete"
                                                title="Remove task"
                                                sx={{ m: '-8px' }}
                                            >
                                                <DeleteIcon fontSize="small" color="error" />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </BusinessCustomListItemStyled>
                            );
                        })}
                    </Box>
                </>
            }
            sx={{
                '&, &.Mui-expanded': {
                    margin: theme.typography.generic.none,
                    marginTop: theme.typography.generic.xLarge,
                    padding: theme.typography.generic.none,
                },

                '& .MuiButtonBase-root.MuiAccordionSummary-root': {
                    padding: theme.typography.generic.xLarge,
                },

                boxShadow: 'none',
                border: `1px solid ${theme.palette.border.neutralPrimary}`,
            }}
            onChange={() => {
                //if accordion expanded then can close or vice versa
                const expandedId = cItem.id === expandedItemId ? '' : cItem.id;
                setExpandedItemId(expandedId);
            }}
            expanded={cItem.id === expandedItemId || false}
        />
    );
}

export default BusinessListItem;
